import { Injectable, inject } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

import { Logger } from '../services/logger/logger';
import { LOGGER } from '../consts/log.enum';
import { INTERCEPTOR_SKIP_ALL_HEADER } from '../consts/interceptor';
import { environment } from '../../../environments/environment';

@Injectable()
export class HttpRequestInterceptor implements HttpInterceptor {
  private logger = inject(Logger);

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // fixme проверка
    if (request.headers.has(INTERCEPTOR_SKIP_ALL_HEADER)) {
      return next.handle(request);
    }

    const newRequest = request.clone({
      url: environment.restApi + request.url,
    });

    this.logger.log('%cService call ', LOGGER.request, newRequest.url);

    return next.handle(newRequest);
  }
}
